<template lang="pug">
div
	v-progress-linear(v-if="$fetchState.pending")
	v-simple-table.similar-table(v-else)
		slot(name="table-header")
			thead
				tr.table-header
					th
					th.text-left {{areas[0].name}}
					th.text-left
						magic-nuxt-link(:to="areas[1]") {{areas[1].name}}
					th.text-left
						magic-nuxt-link(:to="areas[2]") {{areas[2].name}}
		tbody
			tr
				td
				td(v-for="value, index in tableValues('skimap.url')")
					magic-nuxt-link(:to="areas[index]")
						v-img(v-if="value && value !== '-'" :aspect-ratio="16/9" :src="`${value}?width=640`")
						v-img(v-else src="https://static.wintersport.nl/images/ogimages/ws-wintersporters.jpg" :aspect-ratio="16/9")
			tr
				th {{$t('page.areas._area.similar:table.area.max_elevation')}}
				td(v-for="value in tableValues('maxElevation', 'm')") {{value}}
			template(v-if="!compact")
				tr
					th {{$t('page.areas._area.similar:table.area.min_elevation')}}
					td(v-for="value in tableValues('minElevation', 'm')") {{value}}
				tr
					th {{$t('page.areas._area.similar:table.area.reviews')}}
					td
						v-rating.d-inline.mr-2(v-if="areas[0].reviews.average" :value="areas[0].reviews.average / 2"  half-increments readonly small dense color="#ffb400" background-color="#ffb400")
						.caption.grey--text {{areas[0].reviews.voteCount}} beoordelingen
					td
						v-rating.d-inline.mr-2(v-if="areas[1].reviews.average" :value="areas[1].reviews.average / 2"  half-increments readonly small dense color="#ffb400" background-color="#ffb400")
						.caption.grey--text {{areas[1].reviews.voteCount}} beoordelingen
					td
						v-rating.d-inline.mr-2(v-if="areas[2].reviews.average" :value="areas[2].reviews.average / 2"  half-increments readonly small dense color="#ffb400" background-color="#ffb400")
						.caption.grey--text {{areas[2].reviews.voteCount}} beoordelingen

			heading-row(v-if="!compact") {{$t('page.areas._area.similar:table.piste')}}
			tr
				th {{$t('page.areas._area.similar:table.piste')}}
				td(v-for="value in tableValues('slopeinfo.total', 'km')") {{value}}
			tr
				th {{$t('page.areas._area.similar:table.piste.overview')}}
				td
					slopes-stack-chart.mt-3.mx-auto(v-bind="areas[0].slopeinfo" :slopeMax="parseInt(maxSlopeTotal)")
				td
					slopes-stack-chart.mt-3.mx-auto(v-bind="areas[1].slopeinfo" :slopeMax="parseInt(maxSlopeTotal)")
				td
					slopes-stack-chart.mt-3.mx-auto(v-bind="areas[2].slopeinfo" :slopeMax="parseInt(maxSlopeTotal)")
			template(v-if="!compact")
				tr
					th {{$t('page.areas._area.similar:table.piste.blue')}}
					td.piste-blue(v-for="value in tableValues('slopeinfo.slopeBlue', 'km')") {{value}}
				tr
					th {{$t('page.areas._area.similar:table.piste.red')}}
					td.piste-red(v-for="value in tableValues('slopeinfo.slopeRed', 'km')") {{value}}
				tr
					th {{$t('page.areas._area.similar:table.piste.black')}}
					td.piste-black(v-for="value in tableValues('slopeinfo.slopeBlack', 'km')") {{value}}
				tr
					th {{$t('page.areas._area.similar:table.piste.downhill')}}
					td
						check(:value="hasDownhill(areas[0].resorts.nodes)")
					td
						check(:value="hasDownhill(areas[1].resorts.nodes)")
					td
						check(:value="hasDownhill(areas[2].resorts.nodes)")
			template(v-if="!compact")
				heading-row {{$t('page.areas._area.similar:table.lift')}}
				tr
					th {{$t('page.areas._area.similar:table.lift.gondola')}}
					td(v-for="value in tableValues('slopeinfo.gondola')") {{value}}
				tr
					th {{$t('page.areas._area.similar:table.lift.chairlift')}}
					td(v-for="value in tableValues('slopeinfo.chairlift')") {{value}}
				tr
					th {{$t('page.areas._area.similar:table.lift.tbar')}}
					td(v-for="value in tableValues('slopeinfo.tbar')") {{value}}

			heading-row(v-if="!compact") {{$t('page.areas._area.similar:table.feature')}}
			tr
				th {{$t('page.areas._area.similar:table.feature.beginners')}}
				td(v-for="value in tableFeatures('BEGINNERS')")
					check(:value="value")
			tr
				th {{$t('page.areas._area.similar:table.feature.advanced')}}
				td(v-for="value in tableFeatures('ADVANCED')")
					check(:value="value")
			tr
				th {{$t('page.areas._area.similar:table.feature.kids')}}
				td(v-for="value in tableFeatures('KIDS')")
					check(:value="value")
			tr
				th {{$t('page.areas._area.similar:table.feature.apresski')}}
				td(v-for="value in tableFeatures('APRESSKI')")
					check(:value="value")
			tr
				th {{$t('page.areas._area.similar:table.feature.flat')}}
				td(v-for="value in tableFeatures('FLAT')")
					check(:value="value")
			tr
				th {{$t('page.areas._area.similar:table.feature.restaurants')}}
				td(v-for="value in tableFeatures('RESTAURANTS')")
					check(:value="value")
			tr
				th {{$t('page.areas._area.similar:table.feature.tours')}}
				td(v-for="value in tableFeatures('TOURS')")
					check(:value="value")
			tr
				th {{$t('page.areas._area.similar:table.feature.crowd')}}
				td(v-for="value in tableFeatures('CROWD')")
					check(:value="value")
			tr
				th {{$t('page.areas._area.similar:table.feature.price')}}
				td(v-for="value in tableFeatures('PRICE')")
					check(:value="value")

			heading-row(v-if="!compact") {{$t('page.areas._area.similar:table.snowguarantee')}}
			tr
				th {{$t('page.areas._area.similar:table.snowguarantee.guarantee')}}
				td(v-for="value in tableFeatures('SNOWGUARANTEE')")
					check(:value="value")
			tr(v-if="!compact")
				th {{$t('page.areas._area.similar:table.snowguarantee.season')}}
				td(v-if="areas[0].snowheights.nodes.length > 0") {{areas[0].snowheights.nodes[0].seasonStartsAt ? $dayjs(areas[0].snowheights.nodes[0].seasonStartsAt).format('D MMM') : $t('season.date.unknown')}} - {{areas[0].snowheights.nodes[0].seasonEndsAt ? $dayjs(areas[0].snowheights.nodes[0].seasonEndsAt).format('D MMM') : $t('season.date.unknown')}}
				td(v-else) -
				td(v-if="areas[1].snowheights.nodes.length > 0") {{areas[1].snowheights.nodes[0].seasonStartsAt ? $dayjs(areas[1].snowheights.nodes[0].seasonStartsAt).format('D MMM') : $t('season.date.unknown')}} - {{areas[1].snowheights.nodes[0].seasonEndsAt ? $dayjs(areas[1].snowheights.nodes[0].seasonEndsAt).format('D MMM') : $t('season.date.unknown')}}
				td(v-else) -
				td(v-if="areas[2].snowheights.nodes.length > 0") {{areas[2].snowheights.nodes[0].seasonStartsAt ? $dayjs(areas[2].snowheights.nodes[0].seasonStartsAt).format('D MMM') : $t('season.date.unknown')}} - {{areas[2].snowheights.nodes[0].seasonEndsAt ? $dayjs(areas[2].snowheights.nodes[0].seasonEndsAt).format('D MMM') : $t('season.date.unknown')}}
				td(v-else) -
			template(v-if="!compact")
				heading-row {{$t('page.areas._area.similar:table.route')}}
				tr
					th {{$t('page.areas._area.similar:table.route.general')}}
					td(v-for="value in tableFeatures('ROUTE')")
						check(:value="value")
				tr
					th {{$t('page.areas._area.similar:table.route.distance_city')}}
					td(v-for="value in tableValues('departures.city.distance', 'km')")
						template(v-if="value !== '9999km'") {{value}}
						template(v-else) -
				tr
					th {{$t('page.areas._area.similar:table.route.distance_highway')}}
					td(v-for="value in tableValues('departures.highway.distance', 'km')") {{value}}
				tr
					th {{$t('page.areas._area.similar:table.route.distance_train')}}
					td
						check(:value="hasTrainStation(areas[0].resorts.nodes)")
					td
						check(:value="hasTrainStation(areas[1].resorts.nodes)")
					td
						check(:value="hasTrainStation(areas[2].resorts.nodes)")
				tr
					th {{$t('page.areas._area.similar:table.route.distance_airport')}}
					td {{getTimeInMinutes(areas[0])}}
					td {{getTimeInMinutes(areas[1])}}
					td {{getTimeInMinutes(areas[2])}}
				tr
					th
					td(v-for="value in tableValues('departures.airports[0].distance', 'km')") {{value}}
			template(v-if="!compact && areas[0].skipas")
				heading-row {{$t('page.areas._area.similar:table.skipas')}}
				tr
					th {{$t('page.areas._area.similar:table.skipas.week')}}
					td {{ $n(getSkipasPrice(6, areas[0].skipas.prices), 'currency', $i18n.locale) }}
					td {{ $n(getSkipasPrice(6, areas[1].skipas.prices), 'currency', $i18n.locale) }}
					td {{ $n(getSkipasPrice(6, areas[2].skipas.prices), 'currency', $i18n.locale) }}
				tr
					th {{$t('page.areas._area.similar:table.skipas.day')}}
					td {{ $n(getSkipasPrice(1, areas[0].skipas.prices), 'currency', $i18n.locale) }}
					td {{ $n(getSkipasPrice(1, areas[1].skipas.prices), 'currency', $i18n.locale) }}
					td {{ $n(getSkipasPrice(1, areas[2].skipas.prices), 'currency', $i18n.locale) }}
			tr.v-data-table__empty-wrapper(v-if="showAreaButtons")
				td
				td.text-center
					v-btn.mt-3(small color="primary" outlined exact :to="localePath({name: 'areas-area', params: {area: areas[0].slug}})") {{$t('page.areas.similar:view.area.button')}}
				td.text-center
					v-btn.mt-3(small color="primary" outlined exact :to="localePath({name: 'areas-area', params: {area: areas[1].slug}})") {{$t('page.areas.similar:view.area.button')}}
				td.text-center
					v-btn.mt-3(small color="primary" outlined exact :to="localePath({name: 'areas-area', params: {area: areas[2].slug}})") {{$t('page.areas.similar:view.area.button')}}
			tr.v-data-table__empty-wrapper(v-if="!compact && !showAreaButtons")
				td
				td.text-center(colspan="3")
					v-btn.mt-3(color="primary" outlined exact :to="localePath({name: 'areas-similar', params: {}, query: {}, hash: `#${areas[0].slug}:${areas[1].slug}:${areas[2].slug}`})") {{$t('page.areas._area.similar:compare.areas.button')}}

</template>

<style lang="sass">
.similar-table
  th
    font-weight: bold
    text-align: right !important
    height: 40px !important
    width: 25%
  td
    text-align: center

  @each $name, $color in $piste-colors
    .piste-#{$name}
      color: $color !important
      font-weight: bold
</style>

<script>
import gql from 'graphql-tag';
import get from 'lodash/get';
import SlopesStackChart from '@/components/slopes-stack-chart.vue';
import areasReachability from '@/mixins/areas-reachability.js';

const Check = {
	functional: true,
	render(createElement, context) {
		if (context.props.value) {
			return createElement(
				'ws-icon',
				{ props: { color: 'success', size: '20' } },
				['check']
			);
		} else {
			return createElement('span', { class: 'grey--text' }, ['•']);
		}
	}
};

const HeadingRow = {
	functional: true,
	render(h, context) {
		return h('tr', { class: 'v-data-table__empty-wrapper' }, [
			h('th', { attrs: { colspan: 4 }, class: 'px-0' }, [
				h(
					'v-sheet',
					{
						class: ['mt-6', 'pa-2', 'text-left'],
						props: { color: 'info' }
					},
					[context.children]
				)
			])
		]);
	}
};

const comparisonFragment = gql`
	fragment comparisonData on Area {
		id
		name
		slug
		maxElevation
		minElevation
		skimap: defaultSkimap {
			url
			alt
		}
		reviews {
			voteCount
			average
		}
		slopeinfo {
			total
			slopeBlue
			slopeRed
			slopeBlack
			black_percentage
			red_percentage
			blue_percentage
			green_percentage
			gondola
			chairlift
			tbar
		}
		features {
			title
			rating
			text
			type
		}
		snowheights {
			nodes {
				seasonStartsAt
				seasonEndsAt
			}
		}
		departures {
			highway {
				distance
			}
			airports {
				distance
				minutes
			}
			city(city: $preferedCity) {
				distance
				node {
					id
					name
				}
			}
		}
		resorts {
			nodes {
				hasTrainStation
				hasDownHill
			}
		}
		skipas {
			prices(convertToEuro: true) {
				adult
				days
			}
		}
	}
`;

const getCompareAreas = gql`
	query getAreaSimilarComponent(
		$slug1: String!
		$slug2: String!
		$slug3: String!
		$preferedCity: String!
	) {
		area1: area(slug: $slug1) {
			...comparisonData
		}
		area2: area(slug: $slug2) {
			...comparisonData
		}
		area3: area(slug: $slug3) {
			...comparisonData
		}
	}
	${comparisonFragment}
`;

export default {
	components: { SlopesStackChart, Check, HeadingRow },
	mixins: [areasReachability],
	props: {
		slugs: {
			type: Array,
			required: false,
			default() {
				return this.$i18n.locale === 'de-DE'
					? [
							'skiwelt-wilder-kaiser',
							'les-trois-vallees',
							'val-gardena-groeden'
					  ]
					: ['skiwelt', 'troisvallees', 'valgardena'];
			}
		},
		compact: {
			type: Boolean,
			default: false
		},
		showAreaButtons: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			areas: []
		};
	},
	async fetch() {
		await this.$graphClient
			.query({
				query: getCompareAreas,
				variables: {
					slug1: this.slugs[0],
					slug2: this.slugs[1],
					slug3: this.slugs[2],
					preferedCity: this.$store.getters.preferedCity
				}
			})
			.then(({ data }) => {
				this.areas = [data.area1, data.area2, data.area3];
			});
	},
	computed: {
		maxSlopeTotal() {
			const slopeTotals = [
				this.areas[0].slopeinfo.total,
				this.areas[1].slopeinfo.total,
				this.areas[2].slopeinfo.total
			];
			return slopeTotals
				.sort(function (a, b) {
					return a - b;
				})
				.reverse()[0];
		}
	},
	watch: {
		slugs() {
			this.$fetch();
		}
	},
	methods: {
		tableValues(key, addition = '', fallback = '-') {
			return [
				get(this.areas[0], key, fallback),
				get(this.areas[1], key, fallback),
				get(this.areas[2], key, fallback)
			].map(i => {
				return i + addition;
			});
		},
		tableFeatures(key) {
			return [
				this.hasFeature(key, this.areas[0].features),
				this.hasFeature(key, this.areas[1].features),
				this.hasFeature(key, this.areas[2].features)
			];
		},
		hasDownhill(obj) {
			const downhill = obj.find(o => o.hasDownHill);
			return !!downhill;
		},
		hasTrainStation(obj) {
			const trainstation = obj.find(o => o.hasTrainStation);
			return !!trainstation;
		},
		getSkipasPrice(day, prices) {
			const price = prices.find(p => p.days === day);
			return !price || !price.adult ? 0 : price.adult;
		},
		hasFeature(type, features) {
			const feature = features.find(f => f.type === type);
			return !(!feature || feature.rating <= 2);
		},
		getTimeInMinutes(area) {
			if (!area.departures.airports.length) return '-';
			return this.$t('page.areas._area.reachability:{time}_to_drive', {
				time: this.formatMinutes(area.departures.airports[0].minutes)
			});
		}
	}
};
</script>
